import React, { useEffect, useMemo, useRef, useState } from 'react';

const ADJUST_CALLBACK_TEMPLATE = 'https://banda-api.space/api/adjust/callback?token=<CALLBACK_TOKEN>&app_id={app_id}&type={activity_kind}&tracker={tracker}&tracker_name={tracker_name}&network_name={network_name}&campaign_name={campaign_name}&adgroup_name={adgroup_name}&creative_name={creative_name}&reftag={reftag}&gps_adid={gps_adid}&ip_address={ip_address}&device_name={device_name}';
const ADJUST_IOS_CALLBACK_TEMPLATE = 'https://banda-api.space/api/adjust/callback-ios?token=<CALLBACK_TOKEN>&app_id=<BUNDLE_ID>&type={activity_kind}&idfa={idfa}&idfv={idfv}&tracker={tracker}&tracker_name={tracker_name}&network_name={network_name}&campaign_name={campaign_name}&adgroup_name={adgroup_name}&creative_name={creative_name}&ip_address={ip_address}&device_name={device_name}';

const FLAGS_REQUEST_EXAMPLE = 'curl -H "X-Flags-Key: <FLAGS_KEY>" https://banda-api.space/api/flags/android/com.example.app';
const FLAGS_RESPONSE_EXAMPLE = `{
  "appId": "com.example.app",
  "platform": "android",
  "flags": {
    "promo_banner": { "enabled": true, "value": "summer" },
    "new_paywall": { "enabled": false, "value": "" }
  }
}`;

const REASON_ROWS = [
  ['200', 'Клік пройшов нормально', 'Проблема не у фільтрах — дивитись Final URL', 'pass'],
  ['ip blocked …', 'IP потрапив у спільний список діапазонів', 'Перевірити IP blocklist — у записі вказано правило, яке спрацювало', 'block'],
  ['provider blocked …', 'IP належить дата-центру', 'Це бот або емулятор. Так і має бути', 'block'],
  ['geo blocked XX', 'Країна у списку заблокованих', 'Перевірити Blocked countries — можливо, країну додали зайвою', 'block'],
  ['proxy blocked', 'IP за проксі або VPN', 'Якщо скарг багато — вимкнути Proxy / VPN для цього додатка', 'block'],
  ['risk blocked N', 'Оцінка ризику ≥ порога', 'Дивитись N. Якщо він близько порога — поріг занизький, підняти', 'block'],
  ['sub_id_1 blocked', 'Неймінг у чорному списку', 'Перевірити список у Settings і сам неймінг зв’язки', 'block'],
  ['referer blocked', 'Referer збігся з правилом', 'Перевірити Referer blocklist у Settings', 'block'],
  ['app closed', 'Опція isOpen вимкнена', 'Увімкнути на вкладці Settings додатка', 'block'],
  ['app closed for organic', 'Не визначилась зв’язка, увімкнено blockOrganic', 'Або зв’язка налаштована невірно, або вимкнути blockOrganic', 'block'],
  ['app not found for id …', 'Такого App ID у панелі немає', 'Помилка у зв’язці або додаток не заведено', 'block'],
  ['androidId blacklisted', 'Пристрій у чорному списку', 'Прибрати зі списку, якщо потрапив помилково', 'block'],
  ['danger adId', 'Підозрілий рекламний ідентифікатор', 'Так і має бути', 'block'],
  ['binom reject …', 'Binom явно відхилив клік або повернув блокувальну мітку', 'Перевірити Final URL, статус і параметр key у записі', 'block'],
  ['binom timeout …', 'Binom не відповів через мережевий збій, але загальний перемикач дозволив пропустити клік', 'Перевірити доступність Binom; клік уже отримав посилання', 'pass'],
  ['cloaking detected …', 'Після переходу Binom повернув URL із міткою клоакінгу', 'Перевірити зв’язку та Android ID; клік заблоковано', 'block'],
  ['processing', 'Клік щойно прийшов і ще обробляється; S2S-очікування може тривати до 10 секунд', 'Відкрити картку кліка або натиснути «Оновити». Якщо статус не змінюється понад хвилину — передати розробці', 'pending'],
];

const FILTER_CARDS = [
  {
    order: 1,
    name: 'IP blocklist',
    rows: [
      ['Що робить', 'Звіряє IP кліка зі списком діапазонів з розділу **Settings**'],
      ['Формати', 'Одна адреса, підмережа CIDR або діапазон через дефіс. IPv4 та IPv6'],
      ['Коли вмикає', 'Завжди. Список спільний, перемикача в картці додатка немає'],
      ['У Click Log', '`ip blocked 8.34.208.0/20` — правило, яке спрацювало, видно в записі'],
    ],
  },
  {
    order: 2,
    name: 'IP blacklist (ISP)',
    rows: [
      ['Що робить', 'Визначає провайдера IP і блокує трафік із дата-центрів'],
      ['Навіщо', 'Ловить серверні заходи і ботів — з телефону живої людини такий IP не приходить'],
      ['Де список', 'Settings → За даними кліка → Провайдери. Зараз там `google`'],
      ['У Click Log', '`provider blocked Google LLC`'],
    ],
  },
  {
    order: 3,
    name: 'Geo block',
    rows: [
      ['Що робить', 'Визначає країну за IP і блокує, якщо вона є у списку **Blocked countries**'],
      ['Як заповнювати', 'Дволітерні коди країн, Enter після кожного. При першому вмиканні підставляються: US, CN, HK, IR, AS, VI, GU, MH, PW, PR, MP, SG'],
      ['Коли вмикати', 'Коли трафік потрібно спрямовувати лише на конкретні ГЕО або відсікти країни модерації'],
      ['У Click Log', '`geo blocked US` — країна вказана прямо в записі'],
    ],
  },
  {
    order: 4,
    name: 'Proxy / VPN',
    rows: [
      ['Що робить', 'Дивиться одне поле відповіді proxycheck.io — `proxy`. Прийшло `yes` — клік заблоковано. Число risk при цьому не враховується взагалі'],
      ['Що потрапляє', 'VPN-сервіси, публічні та резидентні проксі, TOR, а також хмарні діапазони: AWS і Google Cloud сервіс позначає типом VPN'],
      ['Обмеження', 'Користувач з увімкненим VPN отримує той самий `proxy: yes` і блокується разом із ботами. Фільтр не відрізняє бота від користувача'],
      ['У Click Log', '`proxy blocked`'],
    ],
  },
  {
    order: 5,
    name: 'Trust score',
    rows: [
      ['Що робить', 'Бере у proxycheck.io оцінку ризику від 0 до 100 і блокує все, що **більше або дорівнює** порогу'],
      ['Поріг', 'За замовчуванням **75**. Докладно — у розділі «Який Trust score ставити»'],
      ['Економія', 'Ділить один запит до proxycheck.io з фільтром Proxy / VPN. Обидва вимкнені — запит не надсилається'],
      ['У Click Log', '`risk blocked 82` — фактична оцінка видна в записі'],
    ],
  },
  {
    order: 6,
    name: 'sub_id_1 blocklist',
    rows: [
      ['Що робить', 'Звіряє `sub_id_1` кліка зі списком з розділу **Settings**'],
      ['Навіщо', 'Блокує тестові й підозрілі неймінги: `test`, `launch`, `facebook`, `qwerty`'],
      ['Коли вмикати', 'Завжди. Увімкнений за замовчуванням'],
      ['У Click Log', '`sub_id_1 blocked`'],
    ],
  },
  {
    order: 7,
    name: 'Referer blocklist',
    rows: [
      ['Що робить', 'Звіряє referer кліка зі списком правил'],
      ['Навіщо', 'Відсікає переходи з міток модерації — наприклад `utm_medium=non-organic`'],
      ['Коли вмикати', 'Завжди. Увімкнений за замовчуванням'],
      ['У Click Log', '`referer blocked`'],
    ],
  },
];

const SECTIONS = [
  {
    id: 'panel',
    title: 'Як влаштована панель',
    blocks: [
      { type: 'p', text: 'У верхньому меню сім розділів. Видимі вкладки залежать від прав користувача — виняток лише **Docs**, яка доступна всім. Android та iOS налаштовуються окремо.' },
      {
        type: 'table',
        head: ['Розділ', 'Що всередині'],
        rows: [
          ['Android', 'Список Android-додатків. Тут же кнопка додавання нового'],
          ['iOS', 'Те саме для iOS. Налаштування частково відрізняються'],
          ['Click Log', 'Усі кліки, пошук, причини блокувань і повторні кліки'],
          ['Settings', 'Загальні налаштування та спільні правила для всього трафіку'],
          ['Team', 'Користувачі панелі, їхні права, паролі та доступ'],
          ['Audit', 'Журнал входів і змін у панелі'],
          ['Docs', 'Ця сторінка'],
        ],
      },
    ],
  },
  {
    id: 'new-app',
    title: 'Як додати застосунок',
    blocks: [
      {
        type: 'steps',
        items: [
          ['Оберіть платформу', 'Вкладка **Android** або **iOS** — від цього залежить набір налаштувань'],
          ['Натисніть кнопку додавання', 'Праворуч зверху, поруч із заголовком Dashboard'],
          ['Заповніть App ID та App URL', '**App ID** — пакет додатка, наприклад `com.example.app`. **App URL** — посилання, куди йде користувач'],
          ['Перевірте посилання', 'Відкрийте App URL у браузері та переконайтеся, що адреса працює до запуску трафіку'],
          ['Увімкніть потрібні опції', 'Блок **Options** праворуч. Мінімум — `isOpen`, інакше додаток не приймає кліки'],
          ['Save', 'Кнопка у правому верхньому куті. Без неї нічого не збережеться'],
        ],
      },
      {
        type: 'note',
        tone: 'info',
        title: 'App ID змінити не можна',
        text: 'Під час редагування поле App ID заблоковане — з ним пов’язані всі кліки. Якщо під час створення сталася помилка, застосунок потрібно створити повторно.',
      },
      {
        type: 'note',
        tone: 'warn',
        title: 'Видалення незворотне',
        text: 'Видалення прибирає застосунок, його налаштування трафіку та фільтрів, виданий Click Token і всі збережені кліки разом із повторами. Нові кліки на цей App ID більше не обробляються. Спільні списки блокувань не змінюються. Для підтвердження панель просить ввести App ID повністю, символ у символ.',
      },
      { type: 'h', text: 'Click Token — захист від чужих кліків' },
      { type: 'p', text: 'Поки `clickTokenEnabled` вимкнено, endpoint приймає кліки без окремого токена. Після ввімкнення кожен запит має передавати актуальний токен **у заголовку** `X-Click-Token`. Інших способів передати токен немає — у параметрах URL він не приймається.' },
      {
        type: 'table',
        head: ['Що прийшло', 'Відповідь', 'Текст помилки'],
        rows: [
          ['Заголовка немає', '401', '`X-Click-Token required`'],
          ['Токен не збігається або для додатка токен не згенеровано', '401', '`Invalid X-Click-Token`'],
          ['У запиті немає `appId`', '400', '`appId is required`'],
          ['Такого App ID немає', '404', "`App '<id>' not found`"],
        ],
      },
      {
        type: 'note',
        tone: 'warn',
        title: 'Порядок важливий',
        text: 'Спочатку натисніть **Generate**, передайте токен тому, хто налаштовує інтеграцію, і лише потім увімкніть перемикач. Кнопка **Generate** записує новий токен одразу, ще до натискання **Save**, і попередній токен стає недійсним у ту саму мить. Якщо перемикач уже ввімкнено, увесь трафік зі старим токеном почне отримувати 401.',
      },
    ],
  },
  {
    id: 'options',
    title: 'Опції додатка',
    blocks: [
      { type: 'p', text: 'Блок **Options** на вкладці Settings додатка. Набір залежить від платформи.' },
      {
        type: 'table',
        head: ['Опція', 'Що робить', 'Платформа'],
        rows: [
          ['isOpen', 'Головний перемикач. Вимкнено — усі кліки отримують 202 і запис `app closed`', 'обидві'],
          ['blockOrganic', 'Блокує кліки, у яких не вдалося визначити рекламну зв’язку', 'обидві'],
          ['fbApi', 'Дозволяє дотягувати атрибуцію через Facebook, коли джерело — Meta', 'Android'],
          ['uacApi', 'Те саме для Google Ads (UAC). Працює разом зі списком UAC Link IDs', 'обидві'],
          ['asaApi', 'Атрибуція через Apple Search Ads. Налаштовується на вкладці ASA', 'iOS'],
          ['FbDrop', 'При перевищенні ліміту кліків підмінює `sub_id_1` — трафік іде, але позначається', 'обидві'],
          ['simulatorApi', 'Надсилає дані кліка в push-сервіс', 'обидві'],
          ['trustedCheck', 'Додаткова перевірка довіри до кліка', 'iOS'],
          ['geoUrlEnabled', 'Для вибраних країн замінює основний App URL на окремий Geo URL', 'обидві'],
          ['adjustS2S', 'Надсилає сесію в Adjust і використовує callback Adjust для атрибуції. Android та iOS налаштовуються окремо, кожен у своєму додатку', 'обидві'],
          ['adjustTestMode', 'Перевірка Adjust S2S: для кожного запиту створюється новий тимчасовий ідентифікатор (Android ID або IDFV)', 'обидві'],
        ],
      },
      {
        type: 'note',
        tone: 'warn',
        title: 'Дві опції зупиняють трафік миттєво',
        text: '`isOpen` зупиняє всі кліки. `blockOrganic` повертає 202 лише тоді, коли атрибуцію не визначено. Якщо трафік перестав проходити, перевірте ці опції насамперед.',
      },
    ],
  },
  {
    id: 'custom-flags',
    title: 'Custom flags',
    blocks: [
      { type: 'p', text: 'Вкладка **Custom flags** у редакторі додатка. Кожен прапорець має назву, перемикач і рядок. Трафік вони не змінюють: значення читають розробники, щоб керувати поведінкою додатка без нового релізу.' },
      {
        type: 'steps',
        items: [
          ['Відкрийте додаток', 'Android або iOS → потрібний додаток → вкладка **Custom flags**'],
          ['Додайте прапорець', 'Назва: латинські літери, цифри, `_`, `.` та `-`, до 64 символів. У межах додатка назви не повторюються'],
          ['Увімкніть і заповніть рядок', 'Рядок необов’язковий, до 2000 символів. Пробіли на початку й у кінці обрізаються'],
          ['Save', 'Прапорці зберігаються разом з іншими налаштуваннями додатка. До 50 прапорців на додаток'],
        ],
      },
      { type: 'h', text: 'Запит для розробників' },
      { type: 'p', text: 'Для iOS у шляху замість `android` вказується `ios`. Відповідь містить усі прапорці додатка, увімкнені й вимкнені, у тому порядку, в якому вони стоять у панелі.' },
      { type: 'code', text: FLAGS_REQUEST_EXAMPLE, label: 'Запит прапорців' },
      { type: 'code', text: FLAGS_RESPONSE_EXAMPLE, label: 'Відповідь із прапорцями' },
      {
        type: 'table',
        head: ['Відповідь', 'Коли'],
        rows: [
          ['200', 'Додаток знайдено. Порожній `flags` означає, що прапорців немає'],
          ['401', 'Немає заголовка `X-Flags-Key` або ключ невірний'],
          ['404', 'Такого App ID на цій платформі немає'],
          ['503', 'Ключ не налаштовано на сервері'],
        ],
      },
      {
        type: 'note',
        tone: 'info',
        title: 'Android та iOS окремо',
        text: 'Прапорці прив’язані до платформи. Якщо App ID однаковий на обох платформах, кожна має власний набір прапорців.',
      },
      {
        type: 'note',
        tone: 'warn',
        title: 'Ключ лише для читання прапорців',
        text: '`X-Flags-Key` відкриває тільки цей запит і не підходить для інших запитів API. Automation-ключ, навпаки, не відкриває прапорці. Ключ видає адміністратор сервера, передається він тільки в заголовку.',
      },
    ],
  },
  {
    id: 'geo-domain',
    title: 'Geo Domain',
    blocks: [
      { type: 'p', text: '`geoUrlEnabled` дає змогу віддавати інший App URL користувачам із вибраних країн. Опція працює для Android та iOS і **обирає лише адресу**: атрибуція, фільтри й перевірка Binom працюють так само, як і для основного App URL.' },
      {
        type: 'steps',
        items: [
          ['Увімкніть geoUrlEnabled', 'У блоці **Options** потрібного додатка'],
          ['Вкажіть Geo URL', 'Повна адреса з протоколом `https://` і потрібним шляхом'],
          ['Додайте країни', 'Дволітерні ISO-коди, наприклад `RU`, `UA`, `DE`; після кожного натисніть Enter. Регістр не має значення — панель сама приводить коди до великих літер. При першому ввімкненні підставляється `RU`'],
          ['Збережіть', 'Для IP із вибраної країни система використає Geo URL, для решти — основний App URL'],
        ],
      },
      {
        type: 'note',
        tone: 'warn',
        title: 'Не плутайте з Blocked countries',
        text: 'Це два різні списки країн. **Countries** у блоці Geo Domain лише перемикає адресу і нікого не блокує. **Blocked countries** у фільтрах відсікає клік і пише `geo blocked XX`.',
      },
      {
        type: 'note',
        tone: 'info',
        title: 'Безпечне повернення до основного URL',
        text: 'Якщо Geo URL порожній, список країн порожній або країну за IP не визначено, система використовує основний App URL. Помилково увімкнена опція без заповнених полів нічого не ламає.',
      },
    ],
  },
  {
    id: 'tabs',
    title: 'Attribution та ASA',
    blocks: [
      { type: 'h', text: 'Attribution' },
      { type: 'p', text: 'Одне поле — **UAC Link IDs**, список ідентифікаторів Google Ads, **по одному в рядку**. Потрібен, щоб система впізнавала кампанії UAC. Працює в парі з опцією `uacApi`.' },
      { type: 'h', text: 'ASA — тільки для iOS' },
      { type: 'p', text: 'Три поля для доступу до Apple Search Ads:' },
      {
        type: 'list',
        items: [
          '**ASA Client ID** — ідентифікатор клієнта',
          '**Bearer Token** — токен доступу',
          '**JW Token** — ключ підпису',
        ],
      },
      { type: 'p', text: 'Значення надає відповідальний за налаштування рекламного кабінету.' },
    ],
  },
  {
    id: 'adjust-s2s',
    title: 'Adjust S2S — Android',
    blocks: [
      { type: 'p', text: 'Інтеграція реєструє Android-сесію в Adjust і отримує атрибуцію через Global Callback. Коли `adjustS2S` увімкнено, вхідний `naming` не використовується для атрибуції: неймінг формується з callback Adjust через ті самі макроси.' },
      { type: 'h', text: 'Підготовка в Adjust' },
      {
        type: 'steps',
        items: [
          ['Створіть S2S Security Token', 'Adjust → потрібний додаток → **Protection** → **S2S Security**. Цей токен вставляється в поле **S2S Token** у панелі'],
          ['Попросіть Adjust увімкнути S2S', 'Надішліть лист у підтримку Adjust з робочої пошти та вкажіть конкретний додаток. Без підтвердження від Adjust серверні сесії не працюватимуть'],
          ['Увімкніть adjustS2S', 'Android → потрібний додаток → Settings → Options'],
          ['Заповніть токени', '**App Token** і **S2S Token** мають належати тому самому додатку. Без обох значень сесія не надсилається'],
          ['Додайте Global Callback', 'Вставте шаблон нижче та замініть `<CALLBACK_TOKEN>` серверним токеном, який надав розробник'],
          ['Збережіть і перевірте', 'Збережіть callback в Adjust, натисніть **Save** у панелі та виконайте тестовий клік'],
        ],
      },
      { type: 'code', text: ADJUST_CALLBACK_TEMPLATE },
      {
        type: 'note',
        tone: 'warn',
        title: 'Не плутайте два токени',
        text: '**S2S Token** належить конкретному додатку в Adjust і використовується для надсилання сесій. `<CALLBACK_TOKEN>` захищає серверний endpoint callback; його не можна передавати стороннім.',
      },
      { type: 'p', text: 'Шаблон показано незакодованим для перевірки. Якщо Adjust вимагає закодований URL, скористайтеся його інструментом кодування. Макрос `{app_id}` має повертати package name, який збігається з App ID у панелі.' },
      { type: 'h', text: 'Коли клік чекає callback' },
      {
        type: 'table',
        head: ['Ситуація', 'Очікування Adjust', 'Результат'],
        rows: [
          ['adjustS2S вимкнено', 'Немає', 'Основний трафік працює без S2S-затримки'],
          ['Є deeplink або onelink', 'Немає', 'Готова атрибуція використовується одразу; сесія Adjust надсилається окремо'],
          ['Meta або UAC', 'Немає', 'Система чекає лише відповідний сервіс атрибуції, але не callback Adjust'],
          ['TikTok, Unity, Moloco або IronSource з deep_link_value', 'Немає', 'Значення deep link використовується одразу'],
          ['Невизначене джерело або рекламна мережа без deep_link_value', 'До 10 секунд', 'Callback прийшов — обробка продовжується одразу; довше встановленого ліміту клік не чекає'],
          ['Явний organic, тестовий режим вимкнено', 'Немає', 'Клік обробляється як organic'],
          ['Сесію в Adjust не надіслано', 'Немає', 'Без токенів, без ідентифікатора пристрою або за помилки запиту очікування не запускається зовсім'],
        ],
      },
      {
        type: 'note',
        tone: 'info',
        title: 'Що відбувається після таймауту',
        text: 'Якщо callback не прийшов за 10 секунд, атрибуція залишається порожньою. За вимкненого `blockOrganic` клік продовжується через Organic-профіль; за ввімкненого `blockOrganic` API повертає 202. Callback, що прийшов раніше, завершує очікування одразу.',
      },
      { type: 'p', text: 'Для невизначеного джерела Meta, UAC та Adjust запускаються паралельно. Система бере перший успішний неймінг і не затримує відповідь через сервіси, які ще працюють.' },
      { type: 'h', text: 'Як визначається атрибуція' },
      {
        type: 'table',
        head: ['Пріоритет', 'Ключ', 'Що відбувається'],
        rows: [
          ['1', 'adjust_reftag', 'Якщо referer містить `adjust_reftag`, система шукає callback за цим значенням'],
          ['2', 'GPS ADID', 'Якщо збігу немає, система шукає callback за рекламним ідентифікатором'],
          ['3', 'IP', 'Остання спроба — знайти найсвіжіший callback того самого додатка за IP'],
        ],
      },
      { type: 'p', text: 'Ключі перевіряються саме в цьому порядку: перший, за яким знайдено callback, і використовується. За кожним ключем система бере 20 найсвіжіших callback за останні 168 годин і обирає з них найбільш заповнений. Новий callback під час очікування зіставляється з активним кліком у реальному часі. Поля network, campaign, adgroup і creative формують неймінг та записуються в клік. Callback-дані зберігаються 7 днів, далі видаляються автоматично.' },
      { type: 'h', text: 'Тестовий режим' },
      { type: 'p', text: '`adjustTestMode` з’являється лише після ввімкнення `adjustS2S`. Він створює новий тимчасовий Android ID для кожної S2S-сесії та дозволяє перевірити очікування callback на organic-referer.' },
      {
        type: 'note',
        tone: 'warn',
        title: 'Вимкніть після перевірки',
        text: 'На бойовому трафіку `adjustTestMode` має бути вимкнений. Інакше кожен запит виглядатиме для Adjust як новий тестовий пристрій.',
      },
      { type: 'h', text: 'Коли сесія надсилається' },
      { type: 'p', text: 'Поки `adjustS2S` увімкнено, обидва токени заповнені та в кліку є GPS ADID або Android ID, сесія надсилається в Adjust і тоді, коли атрибуцію вже дав deeplink або onelink. Виняток — трафік Meta та UAC: для нього сесія не надсилається, бо Adjust не має даних про ці кліки й приписав би встановлення іншій мережі за власною моделлю.' },
      { type: 'h', text: 'Діагностика callback' },
      { type: 'p', text: 'Відкрийте шаблон callback у браузері, підставивши реальні значення замість макросів. Код відповіді одразу показує, де саме проблема.' },
      {
        type: 'table',
        head: ['Код відповіді', 'Що це означає', 'Що робити'],
        rows: [
          ['204', 'Callback прийнято і збережено', 'Це успіх. Тіло відповіді порожнє — так і має бути'],
          ['400', '`app_id` порожній або відсутній', 'Перевірте, що в Global Callback є `app_id={app_id}` і макрос повертає package name'],
          ['401', 'Невірний `<CALLBACK_TOKEN>`', 'Звіріть токен у callback із тим, який надав розробник'],
          ['503', 'Callback не налаштований на сервері', 'Передайте розробці: серверний токен не заданий'],
          ['Немає відповіді', 'Adjust не достукався до endpoint', 'Перевірте адресу callback і доступність домену'],
        ],
      },
      { type: 'p', text: 'Макроси, які Adjust не зміг підставити, приходять у вигляді `{campaign_name}` і зберігаються як порожнє значення. Якщо в Click Log неймінг частково порожній — саме ці макроси не розкрилися на боці Adjust.' },
      { type: 'h', text: 'Швидка перевірка' },
      {
        type: 'list',
        items: [
          'Підтримка Adjust підтвердила, що S2S увімкнено саме для цього додатка',
          'Обидва токени заповнені без пробілів на початку та в кінці',
          'У callback правильний `<CALLBACK_TOKEN>` і макрос `app_id={app_id}`',
          'Package name у Adjust збігається з App ID у панелі',
          'У бойовому режимі клік містить GPS ADID або Android ID; без ідентифікатора S2S-сесія не надсилається',
          'Для бойового трафіку `adjustTestMode` вимкнений',
          'Після тестового кліка в Click Log заповнені Referer, Ad ID або IP, за якими можна зіставити callback',
          'Якщо неймінг не з’явився, перевірте підтвердження S2S від Adjust, Global Callback і відповідність ідентифікаторів',
        ],
      },
      {
        type: 'note',
        tone: 'warn',
        title: 'Помилка Adjust не зупиняє основний трафік',
        text: 'Відсутній ідентифікатор пристрою, неправильний токен або помилка сесії не блокують клік самі по собі. Клік продовжується без S2S-атрибуції та далі підпорядковується Organic-профілю і `blockOrganic`.',
      },
    ],
  },
  {
    id: 'adjust-s2s-ios',
    title: 'Adjust S2S — iOS',
    blocks: [
      { type: 'p', text: 'Окрема інтеграція для iOS-додатків, Android вона не зачіпає. Система надсилає iOS-сесію в Adjust і бере атрибуцію з callback Adjust або з `inspect_device`. Коли `adjustS2S` увімкнено, вхідний `naming` не використовується: неймінг формується з даних Adjust.' },
      { type: 'h', text: 'Підготовка в Adjust' },
      {
        type: 'steps',
        items: [
          ['Отримайте токени', '**App Token** і **S2S Token** iOS-додатка в Adjust; S2S має бути підтверджений підтримкою Adjust, як і для Android'],
          ['Увімкніть adjustS2S', 'iOS → потрібний додаток → Settings → Options, заповніть обидва токени'],
          ['Додайте callback', 'Вставте шаблон нижче для активності **click**; **install** і **reattribution** необов’язкові та зберігаються для аналізу. Якщо на install уже є інший callback, додайте цей URL через пробіл. Замініть `<CALLBACK_TOKEN>` серверним токеном, а `<BUNDLE_ID>` — Bundle ID, який збігається з App ID у панелі'],
          ['Передавайте ідентифікатори з додатка', 'У запиті `/api/click-ios` передавайте `idfv` і, якщо користувач дозволив відстеження, `idfa`. Якщо `idfv` немає, як IDFV використовується `adId`. Бажано також `userAgent`, `deviceName`, `appVersion`'],
          ['Збережіть і перевірте', 'Натисніть **Save** у панелі та виконайте тестовий клік'],
        ],
      },
      { type: 'code', text: ADJUST_IOS_CALLBACK_TEMPLATE },
      { type: 'p', text: 'Якщо в Adjust callback налаштовано окремо для кожної активності, замість `{activity_kind}` можна вказати фіксоване значення, наприклад `type=CLICK` або `type=INSTALL`. Impression та інші активності приймаються з відповіддю 204, але не зберігаються.' },
      { type: 'h', text: 'Як визначається атрибуція' },
      {
        type: 'table',
        head: ['Пріоритет', 'Джерело', 'Що відбувається'],
        rows: [
          ['1', 'install / reattribution за IDFV', 'Adjust надсилає цей callback приблизно через 30 секунд після сесії, тому для поточного кліку він не встигає. Використовується, якщо для пристрою вже збережено callback'],
          ['2', 'install / reattribution за IDFA', 'Те саме, якщо callback прийшов з IDFA'],
          ['3', 'click за IDFA', 'Клік по рекламі, зафіксований Adjust до встановлення'],
          ['4', 'inspect_device за IDFA', 'Запит до Adjust Device API, до 3 спроб. Без IDFA недоступний: Adjust шукає лише за рекламним ідентифікатором'],
        ],
      },
      { type: 'p', text: 'Без IDFA система один раз перевіряє збережені callback і відповідає одразу, як і без S2S. З IDFA перевірка та `inspect_device` повторюються щосекунди до 10 секунд. Callback з organic завершує очікування одразу. Callback шукається за останні 168 годин, зберігається 7 днів.' },
      { type: 'h', text: 'Коли клік чекає Adjust' },
      {
        type: 'table',
        head: ['Ситуація', 'Очікування Adjust', 'Результат'],
        rows: [
          ['adjustS2S вимкнено', 'Немає', 'iOS-додаток працює як раніше'],
          ['Є deeplink (Meta)', 'Немає', 'Атрибуція з deeplink, сесія в Adjust не надсилається'],
          ['Немає deeplink, є IDFA', 'До 10 секунд', 'UAC, ASA та Adjust запускаються паралельно, береться перший успішний неймінг'],
          ['Немає deeplink і IDFA', 'Немає', 'Сесія в Adjust надсилається, відповідь одразу; UAC та ASA працюють як звичайно'],
          ['Сесію не надіслано', 'Немає', 'Без токенів, без IDFV та IDFA або за помилки запиту очікування не запускається'],
        ],
      },
      { type: 'h', text: 'Тестовий режим' },
      { type: 'p', text: '`adjustTestMode` надсилає сесію з новим тимчасовим IDFV і без IDFA, тому Adjust щоразу бачить нове встановлення, а клік не чекає Adjust. На бойовому трафіку його треба вимкнути.' },
    ],
  },
  {
    id: 'flow',
    title: 'Шлях кліка',
    blocks: [
      { type: 'p', text: 'Клік проходить ланцюжок згори вниз. **Спрацьовує перша відповідна перевірка** — наступні вже не виконуються. Тому в Click Log зберігається одна причина блокування.' },
      {
        type: 'flow',
        items: [
          ['Додаток існує і відкритий', 'Перевіряємо `app_id`, опцію `isOpen` і чорний список Android ID', 'block'],
          ['Обираємо App URL', 'За IP визначаємо, чи потрібен основний App URL або Geo URL', ''],
          ['Визначаємо атрибуцію', 'Беремо deeplink, onelink або неймінг; за потреби звертаємося до Meta, UAC, ASA чи Adjust S2S', ''],
          ['Визначаємо тип трафіку', 'За атрибуцією та джерелом обираємо профіль Organic або Non-organic', ''],
          ['Фільтри за IP', 'Список IP, провайдер, гео, Proxy/VPN, Trust score — у цьому порядку', 'block'],
          ['Списки блокувань', 'Спочатку `sub_id_1`, потім referer', 'block'],
          ['Перевіряємо посилання', 'Якщо інтеграція використовує перевірку Binom, явна відмова блокує клік, а мережевий збій обробляється за загальним перемикачем', 'block'],
          ['Клік пройшов', 'Повертаємо готове посилання; після успішної перевірки Binom воно містить `sub_id_12=trusted`', 'pass'],
        ],
      },
      {
        type: 'note',
        tone: 'info',
        title: 'Що бачить користувач при блокуванні',
        text: 'Відповідь HTTP 202 з порожнім тілом — не помилка і не редирект. Для клієнта це виглядає як «нічого не сталося». Причина пишеться в поле clickLog цього кліка.',
      },
    ],
  },
  {
    id: 'profiles',
    title: 'Два профілі трафіку',
    blocks: [
      { type: 'p', text: 'У кожного додатка два незалежні набори фільтрів. Який застосувати — вирішується автоматично за параметрами кліка.' },
      {
        type: 'table',
        head: ['Профіль', 'Коли застосовується', 'Що це за трафік'],
        rows: [
          ['Organic', '`sub_id_1` порожній **і** джерело organic або не визначене', 'Користувач прийшов сам, рекламної зв’язки немає'],
          ['Non-organic', 'Є `sub_id_1` **або** джерело — рекламна мережа', 'Meta, Unity, TikTok, UAC, Moloco, IronSource'],
        ],
      },
      { type: 'p', text: 'Кнопки **Organic → Non-organic** і **Non-organic → Organic** над колонками копіюють налаштування з однієї колонки в іншу.' },
    ],
  },
  {
    id: 'filters',
    title: 'Сім фільтрів за порядком',
    blocks: [
      { type: 'p', text: 'Номер — це позиція в ланцюжку. Якщо спрацював третій, четвертий уже не перевіряється.' },
      { type: 'filters' },
    ],
  },
  {
    id: 'threshold',
    title: 'Який Trust score ставити',
    blocks: [
      { type: 'p', text: 'Оцінку рахує proxycheck.io. Вона складається з базового значення за типом IP плюс історія атак з цієї адреси, тому змінюється з часом.' },
      { type: 'h', text: 'Базові оцінки за типом IP' },
      {
        type: 'table',
        head: ['Тип IP', 'Базова оцінка'],
        rows: [
          ['Hosting — дата-центр', '33'],
          ['VPN', '50'],
          ['Scraper', '75'],
          ['TOR', '75'],
          ['Proxy', '100'],
          ['Compromised — зламаний пристрій', '100'],
        ],
      },
      { type: 'h', text: 'Рекомендація самого сервісу' },
      {
        type: 'table',
        head: ['Оцінка', 'Що радить proxycheck.io'],
        rows: [
          ['0–25', 'Пропускати'],
          ['26–50', 'Пропускати з перевіркою'],
          ['51–75', 'Пропускати з перевіркою'],
          ['76–100', 'Блокувати'],
        ],
      },
      { type: 'p', text: 'У панелі за замовчуванням стоїть **75**. Це трохи суворіше за рекомендацію сервісу, де блокування починається з 76.' },
      { type: 'h', text: 'Що це означає на практиці' },
      { type: 'p', text: 'З порогом 75 автоматично відсікаються Proxy, Compromised, TOR і Scraper — їхня базова оцінка вже дорівнює порогу або вища. Звичайний VPN з базою 50 пройде, якщо за ним не тягнеться історія атак.' },
      { type: 'p', text: 'Опустіть поріг до 50 — почнуть блокуватися всі VPN. До 33 — ще й увесь хостинг. Нижче 33 сенсу немає: там залишаються тільки чисті адреси, і фільтр почне зачіпати живих користувачів.' },
      {
        type: 'note',
        tone: 'info',
        title: 'Як змінювати поріг безпечно',
        text: 'Увімкніть фільтр на поточному значенні, день подивіться записи risk blocked N у Click Log і оцініть, скільки трафіку йде і з якими оцінками. Лише після цього рухайте поріг.',
      },
      { type: 'h', text: 'Trust score і Proxy / VPN — це різні речі' },
      { type: 'p', text: 'Обидва фільтри питають один і той самий сервіс одним запитом, але дивляться **різні поля відповіді**.' },
      {
        type: 'table',
        head: ['', 'Proxy / VPN', 'Trust score'],
        rows: [
          ['Що дивиться', 'поле `proxy`: yes або no', 'число `risk` від 0 до 100'],
          ['Логіка', 'ознака «це точка виходу»', 'репутація адреси за історією'],
          ['Налаштування', 'увімк / вимк', 'поріг, за замовчуванням 75'],
        ],
      },
      { type: 'h', text: 'Живий приклад' },
      { type: 'p', text: 'Адреси Amazon і Google Cloud сервіс віддає так: `proxy: yes`, тип VPN, `risk: 66`. База 50 за VPN плюс 16 за історію атак.' },
      {
        type: 'list',
        items: [
          '**Proxy / VPN** їх заблокує — прапорець стоїть',
          '**Trust score з порогом 75** їх пропустить — 66 менше за поріг',
          '**ISP blacklist** заблокує лише ті адреси, чия організація є у списку: зараз це Google, але не Amazon',
        ],
      },
      { type: 'p', text: 'Мобільні оператори і Apple у тій самій перевірці дали `proxy: no` і `risk: 0` — жодним із трьох фільтрів вони не зачіпаються.' },
      {
        type: 'note',
        tone: 'warn',
        title: 'Чим ловити хмарний трафік',
        text: 'Proxy / VPN виявляє дата-центри, але також блокує користувачів з увімкненим VPN. ISP blacklist працює за назвою організації та не зачіпає мобільні мережі, якщо їхніх провайдерів немає у списку.',
      },
    ],
  },
  {
    id: 'settings',
    title: 'Settings: правила та загальні перемикачі',
    blocks: [
      { type: 'p', text: 'Розділ **Settings** містить три групи: загальні налаштування, правила за даними кліка та списки пристроїв. Зміни тут впливають на всі додатки, до яких застосовується відповідне правило.' },
      { type: 'h', text: 'За даними кліка' },
      {
        type: 'table',
        head: ['Список', 'Що блокує', 'Приклад значення'],
        rows: [
          ['sub_id_1', 'Кліки з таким неймінгом зв’язки', '`test`, `launch`'],
          ['Referer', 'Кліки з таким referer', '`utm_medium=non-organic`'],
          ['IP-адреси', 'Кліки з адрес у вказаних діапазонах', '`8.34.208.0/20`'],
          ['Провайдери', 'Кліки з IP дата-центрів і хостингів', '`google`'],
        ],
      },
      { type: 'h', text: 'Список IP-адрес' },
      { type: 'p', text: 'Приймає три формати запису, усі зводяться до діапазону адрес:' },
      {
        type: 'table',
        head: ['Запис', 'Що це', 'Скільки адрес'],
        rows: [
          ['`13.211.45.54`', 'одна адреса', '1'],
          ['`8.34.208.0/20`', 'підмережа у форматі CIDR', '4 096'],
          ['`34.0.0.0-34.0.227.255`', 'діапазон від і до', '58 368'],
        ],
      },
      { type: 'p', text: 'Число після скісної риски — ширина підмережі: `/24` це 256 адрес, `/20` — 4 096, `/8` — понад 16 мільйонів. Працює і для IPv6.' },
      { type: 'p', text: 'Можна вставити одразу список — по одному правилу в рядку. Панель повідомить, скільки правил додано, скільки вже було і які рядки не вдалося розпізнати.' },
      {
        type: 'note',
        tone: 'warn',
        title: 'Перевірка йде першою',
        text: 'Список IP перевіряється раніше за всі інші фільтри і діє на всі додатки без винятку. Заблокований клік отримує запис ip blocked із вказаним правилом, яке спрацювало.',
      },
      { type: 'h', text: 'За пристроєм' },
      {
        type: 'table',
        head: ['Список', 'Що робить', 'Приклад значення'],
        rows: [
          ['Заборонені', 'Забороняє пристрою отримувати посилання', 'Android ID пристрою'],
          ['Довірені', 'Пропускає пристрій повз фільтри за IP', 'Android ID тестувальника'],
        ],
      },
      {
        type: 'note',
        tone: 'info',
        title: 'Навіщо потрібен білий список',
        text: 'Пристрій з білого списку повністю минає фільтри за IP — провайдер, гео, Proxy/VPN і Trust score не застосовуються. Зручно для своїх тестових телефонів: можна перевіряти зв’язку з офісу або через VPN і не потрапляти під блокування.',
      },
      { type: 'h', text: 'Список провайдерів' },
      { type: 'p', text: 'Значення звіряється з назвою організації з бази ASN **за підрядком**: `google` збігається і з Google LLC, і з Google Cloud. Тому короткі значення треба додавати обережно — вони можуть зачепити більше адрес, ніж очікується.' },
      { type: 'h', text: 'Загальні перемикачі' },
      { type: 'p', text: 'Settings → **Загальні** → **Перемикачі**. Налаштування діють одразу на весь трафік, тому змінювати їх потрібно лише після перевірки наслідків. Зміна підхоплюється протягом приблизно 15 секунд.' },
      {
        type: 'table',
        head: ['Перемикач', 'Вимкнено', 'Увімкнено'],
        rows: [
          ['Пропускати клік, якщо Binom не відповів', 'Таймаут, обрив з’єднання або помилка DNS блокують клік', 'За мережевого збою клік отримує посилання, а в Click Log зберігається `binom timeout`'],
        ],
      },
      {
        type: 'note',
        tone: 'warn',
        title: 'Явна відмова Binom завжди блокує клік',
        text: 'Перемикач спрацьовує тільки тоді, коли запит до Binom взагалі не дійшов: таймаут 10 секунд, обрив з’єднання або помилка DNS. Відповідь зі статусом 400 і вище, блокувальний параметр у посиланні чи мітка клоакінгу відсікають клік завжди, незалежно від перемикача.',
      },
      {
        type: 'note',
        tone: 'warn',
        title: 'Правило додається всім',
        text: 'Списки наскрізні. Перемикач у картці додатка вирішує лише, застосовувати їх до цього додатка чи ні. Зміни підхоплюються протягом хвилини.',
      },
    ],
  },
  {
    id: 'stats',
    title: 'Click Log',
    blocks: [
      { type: 'p', text: 'Розділ відкривається одразу з кліками за сьогодні, найсвіжіші зверху. Порожній App ID означає «усі додатки».' },
      { type: 'h', text: 'Фільтри' },
      {
        type: 'table',
        head: ['Поле', 'Що робить'],
        rows: [
          ['App ID', 'Обмежує одним додатком. Порожнє — усі'],
          ['Період', 'Кнопки Сьогодні / Учора / 7 днів / 30 днів або дати вручну'],
          ['Click Log', 'Пошук за причиною: `geo blocked`, `risk blocked`, `200`'],
          ['Статус', 'Всі, Пройшли або Заблоковані'],
          ['Device ID', 'Пошук за пристроєм'],
          ['Ad ID', 'Пошук за рекламним ідентифікатором'],
          ['Naming / URL / Deeplink / Referer', 'Пошук за неймінгом або будь-яким посиланням кліка'],
        ],
      },
      { type: 'p', text: 'Усі фільтри працюють **на боці сервера, по всьому періоду**, а не по видимій сторінці. Таблиця, лічильник «Знайдено» та блок причин використовують одну відфільтровану вибірку.' },
      { type: 'h', text: 'Лічильники' },
      {
        type: 'list',
        items: [
          '**Знайдено** — скільки кліків підпадає під фільтри за весь період',
          '**На сторінці** — скільки рядків показано зараз',
          '**Заблоковано** — скільки з них відсіяно, і який це відсоток',
        ],
      },
      { type: 'h', text: 'Причини відсіву' },
      { type: 'p', text: 'Смуга показує співвідношення пройдених і заблокованих, під нею — розклад по причинах з кількістю і відсотком. **Рядок клікабельний**: натискання фільтрує таблицю за цією причиною, кнопка «Скинути фільтр» повертає все назад.' },
      { type: 'h', text: 'Таблиця' },
      { type: 'p', text: 'Внизу — сторінки і вибір, скільки рядків показувати: від 50 до 1000. Кнопка **Колонки** ховає зайві стовпці. Довгі значення обрізаються — наведіть курсор, щоб побачити повністю. Натискання на рядок відкриває клік з усіма полями.' },
      { type: 'p', text: 'Статус у стовпці Click Log: `passed` — клік пройшов, `processing` — ще обробляється, решта — текст причини блокування. Колір крапки той самий: зелена, охра, червона. Таблиця показує знімок на момент завантаження, тому свіжий клік може висіти в статусі «Обробляється»: картка кліка при відкритті підтягує актуальні дані сама.' },
      { type: 'h', text: 'Export' },
      { type: 'p', text: 'Кнопка вивантажує CSV **поточної сторінки**. Для більшого обсягу виберіть 1000 рядків на сторінку.' },
    ],
  },
  {
    id: 'repeats',
    title: 'Повторні кліки',
    blocks: [
      { type: 'p', text: 'Click Log → **Повторні кліки** показує пристрої, які зверталися до того самого додатка більше одного разу. Повтор зберігається окремо й не перезаписує перший клік.' },
      { type: 'p', text: 'За замовчуванням показано останні 7 днів. Період, App ID і Device ID задаються у верхньому рядку; кнопка **Оновити** перезавантажує дані.' },
      { type: 'h', text: 'Лічильники вгорі' },
      {
        type: 'table',
        head: ['Лічильник', 'Що показує'],
        rows: [
          ['Повторів', 'Загальна кількість додаткових кліків за вибраний період'],
          ['Пристроїв', 'Скільки унікальних пристроїв заходило більше одного разу'],
          ['У списку', 'Скільки рядків потрапило в таблицю під поточними фільтрами'],
        ],
      },
      { type: 'h', text: 'Три зведені блоки' },
      {
        type: 'table',
        head: ['Блок', 'Що показує', 'Як читати'],
        rows: [
          ['Скільки разів заходили', 'Розподіл пристроїв за загальною кількістю кліків', 'Довгий хвіст на 5+ кліках — ознака автоматизованого трафіку'],
          ['Інтервал між кліками', 'Сім проміжків часу між сусідніми кліками одного пристрою', 'Скупчення в «до 10 сек» — це ретраї або бот, а не жива людина'],
          ['Найбільша частка повторів', 'Додатки з найбільшою часткою повторних звернень', 'Частка рахується як повтори до всіх кліків додатка'],
        ],
      },
      { type: 'p', text: 'Проміжки: `до 10 сек`, `10–60 сек`, `1–5 хв`, `5–30 хв`, `30–60 хв`, `1–24 год`, `понад добу`. Якщо даних замало, блок показує «Недостатньо даних» — це не помилка.' },
      { type: 'h', text: 'Таблиця пристроїв' },
      { type: 'p', text: 'Внизу — список пристроїв із колонками Device ID, App ID, Кліків, Перший повтор і Останній, по 50 рядків на сторінку. Це найшвидший спосіб перевірити конкретну скаргу: вставте Device ID у фільтр і подивіться, скільки разів і з яким інтервалом пристрій заходив.' },
    ],
  },
  {
    id: 'access',
    title: 'Team та Audit',
    blocks: [
      { type: 'h', text: 'Team — керування доступом' },
      { type: 'p', text: 'У розділі **Team** можна створити користувача, вибрати його права, тимчасово вимкнути доступ, змінити пароль або видалити обліковий запис. Логін — від 3 до 40 символів: латиниця, цифри, крапка, дефіс і підкреслення. Пароль — щонайменше 10 символів.' },
      {
        type: 'table',
        head: ['Право', 'Що дозволяє'],
        rows: [
          ['Apps: view', 'Перегляд Android та iOS додатків'],
          ['Apps: create, edit, delete', 'Створення, редагування та видалення додатків'],
          ['Click Log: view and export', 'Перегляд кліків і вивантаження CSV'],
          ['Settings: view', 'Перегляд спільних правил і налаштувань'],
          ['Settings: edit', 'Додавання та видалення правил, зміна загальних перемикачів'],
          ['Team: manage access', 'Керування користувачами та їхніми правами'],
          ['Audit: view', 'Перегляд журналу дій'],
        ],
      },
      { type: 'h', text: 'Коли користувача викидає з панелі' },
      { type: 'p', text: 'Активні сесії завершуються одразу після будь-якої з трьох дій. Користувач побачить вимогу увійти знову — це не збій панелі.' },
      {
        type: 'list',
        items: [
          'Змінено пароль',
          'Змінено набір прав',
          'Обліковий запис вимкнено',
        ],
      },
      { type: 'p', text: 'Свій власний обліковий запис видалити не можна — панель поверне помилку. Щоб прибрати доступ собі, це має зробити інший користувач із правом **Team: manage access**.' },
      { type: 'h', text: 'Audit — журнал дій' },
      { type: 'p', text: 'Розділ **Audit** показує час, користувача, дію, об’єкт, деталі та IP. Фільтри дають змогу знайти зміни за логіном, типом дії, App ID, правилом або IP.' },
      {
        type: 'note',
        tone: 'info',
        title: 'Вкладки залежать від прав',
        text: 'Якщо Team, Audit або інший розділ не видно, це не помилка панелі. Поточному користувачу не видано відповідного права.',
      },
    ],
  },
  {
    id: 'reasons',
    title: 'Розбір скарг: клік не дійшов',
    blocks: [
      { type: 'p', text: 'Знайдіть клік у розділі Click Log і подивіться колонку **Click Log**. Там завжди один рядок — причина.' },
      { type: 'reasons' },
    ],
  },
  {
    id: 'gotchas',
    title: 'Що важливо знати',
    blocks: [
      { type: 'h', text: 'Збій proxycheck.io не блокує трафік' },
      { type: 'p', text: 'Якщо сервіс не відповів, повернув помилку або ключ не налаштований, клік **проходить**. Система не блокує трафік через збій зовнішнього сервісу. У цей час Proxy / VPN і Trust score фактично не працюють, навіть якщо перемикачі увімкнені.' },
      { type: 'h', text: 'Фільтри за IP іноді спрацьовують раніше вибору профілю' },
      { type: 'p', text: 'Чотири фільтри за IP — провайдер, гео, Proxy / VPN і Trust score — налаштовуються окремо для кожного профілю. Якщо в обох колонках вони налаштовані однаково, система перевіряє їх одразу, не чекаючи визначення типу трафіку: це швидше, а результат той самий.' },
      { type: 'h', text: 'Додаток без налаштованих фільтрів' },
      { type: 'p', text: 'Якщо вкладку Filters ніколи не зберігали, працює стара логіка: гео і Proxy беруться зі старих галочок додатка, однаково для обох типів трафіку. Достатньо один раз натиснути **Save** у вкладці Filters.' },
      { type: 'h', text: 'Затримка на віддачу посилання' },
      { type: 'p', text: 'П’ять із семи фільтрів перевіряються локально. Лише Proxy / VPN і Trust score звертаються до зовнішнього сервісу — одним спільним запитом, тому один або обидва фільтри займають однаковий час.' },
      { type: 'p', text: 'Вимкнений `adjustS2S` не додає жодного очікування. За ввімкненого S2S deeplink, onelink, Meta, UAC та рекламні мережі з `deep_link_value` не чекають callback Adjust. Лише невизначене джерело або мережа без deep link може чекати до 10 секунд; callback завершує очікування раніше.' },
      { type: 'p', text: 'Помилка Adjust не блокує клік сама по собі. Якщо атрибуцію не отримано, далі діють Organic-профіль і `blockOrganic`.' },
    ],
  },
];

function inline(text) {
  const parts = String(text).split(/(`[^`]+`|\*\*[^*]+\*\*)/g);

  return parts.map((part, index) => {
    if (part.startsWith('`') && part.endsWith('`') && part.length > 2) {
      return <code key={index} className="docs-code">{part.slice(1, -1)}</code>;
    }

    if (part.startsWith('**') && part.endsWith('**') && part.length > 4) {
      return <strong key={index}>{part.slice(2, -2)}</strong>;
    }

    return <React.Fragment key={index}>{part}</React.Fragment>;
  });
}

function Table({ head, rows }) {
  return (
    <div className="docs-table-scroll">
      <table className="docs-table">
        <thead>
          <tr>{head.map((cell) => <th key={cell}>{cell}</th>)}</tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row[0]}>
              {row.map((cell, index) => (
                <td key={index} className={index === 0 ? 'docs-cell-key' : undefined}>
                  {inline(cell)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function ReasonTable() {
  const [query, setQuery] = useState('');

  const rows = useMemo(() => {
    const needle = query.trim().toLowerCase();
    if (!needle) return REASON_ROWS;
    return REASON_ROWS.filter((row) => row.slice(0, 3).join(' ').toLowerCase().includes(needle));
  }, [query]);

  return (
    <>
      <input
        type="search"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Вставте запис із Click Log…"
        className="form-control docs-search"
      />

      <div className="docs-table-scroll">
        <table className="docs-table">
          <thead>
            <tr><th>Запис у Click Log</th><th>Що сталося</th><th>Що робити</th></tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row[0]}>
                <td className="docs-cell-key">
                  <span className={`docs-dot docs-dot-${row[3]}`} />
                  <code className="docs-code">{row[0]}</code>
                </td>
                <td>{inline(row[1])}</td>
                <td>{inline(row[2])}</td>
              </tr>
            ))}
            {!rows.length ? (
              <tr>
                <td colSpan={3} className="docs-empty">
                  Такого запису у списку немає — передайте клік розробці, це не фільтр
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </>
  );
}

function FilterCards() {
  return (
    <div className="docs-filters">
      {FILTER_CARDS.map((card) => (
        <article key={card.order} className="docs-filter-card">
          <div className="docs-filter-head">
            <span className="docs-filter-order">{card.order}</span>
            <h4 className="docs-filter-name">{card.name}</h4>
          </div>
          <dl className="docs-dl">
            {card.rows.map(([term, description]) => (
              <React.Fragment key={term}>
                <dt>{term}</dt>
                <dd>{inline(description)}</dd>
              </React.Fragment>
            ))}
          </dl>
        </article>
      ))}
    </div>
  );
}

function CodeBlock({ text, label = 'Шаблон callback URL' }) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return undefined;
    const timer = setTimeout(() => setCopied(false), 1600);
    return () => clearTimeout(timer);
  }, [copied]);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className="docs-code-wrap">
      <button type="button" className="docs-copy" onClick={copy}>
        {copied ? 'Скопійовано' : 'Копіювати'}
      </button>
      <div className="docs-code-block" role="region" aria-label={label} tabIndex={0}>
        <code>{text}</code>
      </div>
    </div>
  );
}

function Block({ block }) {
  if (block.type === 'p') return <p className="docs-p">{inline(block.text)}</p>;

  if (block.type === 'h') return <h4 className="docs-h">{block.text}</h4>;

  if (block.type === 'list') {
    return (
      <ul className="docs-list">
        {block.items.map((item) => <li key={item}>{inline(item)}</li>)}
      </ul>
    );
  }

  if (block.type === 'table') return <Table head={block.head} rows={block.rows} />;

  if (block.type === 'code') return <CodeBlock text={block.text} label={block.label} />;

  if (block.type === 'reasons') return <ReasonTable />;

  if (block.type === 'filters') return <FilterCards />;

  if (block.type === 'note') {
    return (
      <div className={`docs-note docs-note-${block.tone}`}>
        <div className="docs-note-title">{block.title}</div>
        <p className="docs-note-text">{inline(block.text)}</p>
      </div>
    );
  }

  if (block.type === 'steps') {
    return (
      <ol className="docs-steps">
        {block.items.map(([title, description], index) => (
          <li key={title}>
            <span className="docs-step-num">{index + 1}</span>
            <div>
              <div className="docs-step-title">{title}</div>
              <div className="docs-step-desc">{inline(description)}</div>
            </div>
          </li>
        ))}
      </ol>
    );
  }

  if (block.type === 'flow') {
    return (
      <div className="docs-flow">
        {block.items.map(([title, description, tone], index) => (
          <div key={title} className="docs-flow-step">
            <span className={`docs-flow-num${tone === 'pass' ? ' is-pass' : ''}`}>
              {tone === 'pass' ? '✓' : index + 1}
            </span>
            <div className="docs-flow-body">
              <div className="docs-step-title">{title}</div>
              <div className="docs-step-desc">{inline(description)}</div>
            </div>
            {tone ? (
              <span className={`docs-verdict docs-verdict-${tone}`}>
                {tone === 'pass' ? 'посилання' : '202, порожньо'}
              </span>
            ) : null}
          </div>
        ))}
      </div>
    );
  }

  return null;
}

const SCROLL_OFFSET = 96;

export default function DocsPanel() {
  const [active, setActive] = useState(SECTIONS[0].id);
  const lockRef = useRef(0);
  const navRef = useRef(null);

  const goTo = (id) => {
    lockRef.current = Date.now() + 700;
    setActive(id);
    const node = document.getElementById(`docs-section-${id}`);
    if (node) node.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (window.history?.replaceState) {
      window.history.replaceState(null, '', `#${id}`);
    }
  };

  useEffect(() => {
    const id = window.location.hash.replace('#', '');
    if (!id || !SECTIONS.some((section) => section.id === id)) return;
    const node = document.getElementById(`docs-section-${id}`);
    if (!node) return;
    lockRef.current = Date.now() + 700;
    setActive(id);
    node.scrollIntoView({ block: 'start' });
  }, []);

  useEffect(() => {
    let frame = 0;

    const sync = () => {
      frame = 0;
      if (Date.now() < lockRef.current) return;

      let current = SECTIONS[0].id;

      for (const section of SECTIONS) {
        const node = document.getElementById(`docs-section-${section.id}`);
        if (node && node.getBoundingClientRect().top <= SCROLL_OFFSET) current = section.id;
      }

      const scrolledToEnd = window.innerHeight + window.scrollY >= document.body.scrollHeight - 4;
      if (scrolledToEnd) current = SECTIONS[SECTIONS.length - 1].id;

      setActive((prev) => (prev === current ? prev : current));
    };

    const onScroll = () => {
      if (!frame) frame = window.requestAnimationFrame(sync);
    };

    sync();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    return () => {
      if (frame) window.cancelAnimationFrame(frame);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);

  useEffect(() => {
    const nav = navRef.current;
    const link = nav?.querySelector('.docs-nav-link.is-active');
    if (!nav || !link) return;

    const navBox = nav.getBoundingClientRect();
    const linkBox = link.getBoundingClientRect();

    if (linkBox.top < navBox.top) nav.scrollTop -= navBox.top - linkBox.top + 8;
    else if (linkBox.bottom > navBox.bottom) nav.scrollTop += linkBox.bottom - navBox.bottom + 8;
  }, [active]);

  return (
    <div className="row g-3 align-items-start mt-1 docs-layout">
      <div className="col-12 col-lg-3 docs-nav-col">
        <nav className="app-editor-card compact-card docs-nav" aria-label="Розділи документації">
          <div className="app-editor-card-body compact-card-body">
            <ol className="docs-nav-list" ref={navRef}>
              {SECTIONS.map((section) => (
                <li key={section.id}>
                  <button
                    type="button"
                    className={`docs-nav-link${active === section.id ? ' is-active' : ''}`}
                    onClick={() => goTo(section.id)}
                  >
                    {section.title}
                  </button>
                </li>
              ))}
            </ol>
          </div>
        </nav>
      </div>

      <div className="col-12 col-lg-9">
        <div className="docs-sections">
          {SECTIONS.map((section) => (
            <section
              key={section.id}
              id={`docs-section-${section.id}`}
              className="app-editor-card compact-card docs-section"
            >
              <div className="app-editor-card-body compact-card-body">
                <h3 className="docs-section-title">{section.title}</h3>
                {section.blocks.map((block, blockIndex) => (
                  <Block key={blockIndex} block={block} />
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
